module.exports = "<router-view></router-view> ";


//////////////////
// WEBPACK FOOTER
// ./src/appBackend/components/page/community/community/community.tpl
// module id = 882
// module chunks = 2